/**
 * This is the changeforgottenpassword module configuration.
 * Do NOT configure routes in this file.
 * @memberOf changeforgottenpassword Module
 * @namespace changeforgottenpassword Config
 */

/**
 * @name config
 * @desc Configures the module.
 * @memberOf changeforgottenpassword Module.changeforgottenpassword Config
 * @ngInject
 */
var config = function () {
}

export default config;


// WEBPACK FOOTER //
// ./src/login/changeforgottenpassword/changeforgottenpassword.config.js